/**
 * 用户信息接口
 */
export interface UserInfo {
  /** 用户ID */
  userId?: string;
  /** 用户名 */
  username?: string;
  /** 用户姓名 */
  userName?: string;
  /** 密码 */
  password: string;
  /** 密码加密类型 */
  passwordEncryptType?: 'SM2';
  /** 验证码 */
  code?: string;
  /** UUID */
  uuid?: string;
  /** 部门名称 */
  deptName?: string;
  /** 昵称 */
  nickName?: string;
  /** 头像 */
  avatar?: string;
  /** 邮箱 */
  email?: string;
  /** 手机号 */
  phonenumber?: string;
  /** 角色名称 */
  roleName?: string;
  /** 性别 */
  sex?: string;
  /** 状态(1正常 0停用) */
  status?: '1' | '0';
  /** 是否是admin */
  isAdmin?: boolean;
  /** 组织机构id */
  deptId?: string;
  /** 组织机构 */
  dept?: any;
}

/** 验证码响应数据接口 */
export interface CaptchaResponseData {
  /** 验证码图片base64 */
  img: string;
  /** 验证码UUID */
  uuid: string;
  /** 是否开启验证码 */
  captchaOnOff?: boolean;
}

/** SM2 公钥响应数据 */
export interface Sm2PublicKeyResponseData {
  /** 公钥 */
  publicKey?: string;
  /** 接口响应数据中的公钥 */
  data?: string | { publicKey?: string };
}

/** SM2 公钥响应 */
export type Sm2PublicKeyResponse = string | Sm2PublicKeyResponseData;

/**
 * 用户登录
 * @param data 登录参数
 * @returns 登录成功后返回token
 */
export function login(data: UserInfo): Promise<{ token: string }> {
  return request({
    url: '/login',
    method: 'post',
    data,
  });
}

/**
 * 获取登录密码 SM2 公钥
 * @returns SM2 公钥响应数据
 */
export function getSm2PublicKey(): Promise<Sm2PublicKeyResponse> {
  return request({
    url: '/sm2-public-key',
    method: 'get',
  });
}

/**
 * 解锁登录
 * @param data 解锁登录参数
 * @returns 解锁成功后返回token
 */
export function unlock(data: UserInfo): Promise<{ token: string }> {
  return request({
    url: '/unLockLogin',
    method: 'post',
    data,
  });
}

/**
 * 三方token登录
 * @param triToken 三方token
 * @returns 登录成功后返回系统token
 */
export function tokenLogin(triToken: string): Promise<{ token: string }> {
  return request({
    url: '/tokenLogin?triToken=' + triToken,
    method: 'get',
  });
}

/**
 * 模拟用户登录
 * @param username 用户名
 * @returns 登录成功后返回token
 */
export function simulationLogin(username: string): Promise<{ token: string }> {
  return request({
    url: '/simulationLogin',
    method: 'post',
    data: {
      username: username,
    },
  });
}

/**
 * 模拟用户登录
 * @param username 用户名
 * @returns 登录成功后返回token
 */
export function switchUserLogin(username: string): Promise<{ token: string }> {
  return request({
    url: '/simulationLoginByBindUser',
    method: 'post',
    data: {
      username: username,
    },
  });
}

/**
 * 获取验证码
 * @returns 验证码响应数据
 */
export function getCodeImg(): Promise<CaptchaResponseData> {
  return request({
    url: '/captchaImage',
    method: 'get',
    timeout: 20000,
  });
}

/**
 * 用户登出
 * @returns 登出结果
 */
export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  });
}

/**
 * 获取用户信息
 * @returns 用户信息
 */
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
  });
}
